import { render, staticRenderFns } from "./DosyadaHacizliMalinSatisiTalepEvrakForm.vue?vue&type=template&id=9e2838a8"
import script from "./DosyadaHacizliMalinSatisiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./DosyadaHacizliMalinSatisiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports